import { render, staticRenderFns } from "./CrewAddress.vue?vue&type=template&id=30976522&scoped=true&"
import script from "./CrewAddress.vue?vue&type=script&lang=js&"
export * from "./CrewAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30976522",
  null
  
)

export default component.exports